// extracted by mini-css-extract-plugin
module.exports = {"intro":"_404-module--intro--2OCXb","missingEmoji":"_404-module--missing-emoji--QGnfh"};